<template>
  <card
    v-if="point"
    class="card"
    :title="`Cliente: ${point.client.name} - Ponto: ${point.id} - Plano atual: ${point.plan.name}`"
  >
    <span style="color: #4CD964; font-size: 20px;"> Valor do plano atual: R${{
        (point.plan.price - 20).toFixed(2).replace('.', ',')
      }} c/ fid. ou R${{ point.plan.price.toFixed(2).replace('.', ',') }}</span>
    <div>
      <form @submit.prevent="updatePlan" novalidate>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label for="exampleFormControlTextarea1"
              >Escolha o tipo de alteração</label
              >
              <select v-model="planChangeType" @change="updatePlanList" class="form-control input i-width" required>
                <option :value="null" selected disabled>Selecione...</option>
                <option value="1074">Upgrade de Plano</option>
                <option value="1107">Downgrade de Plano</option>
                <option value="1099">Atualização de Plano</option>
              </select>
              <span v-show="planChangeType !== null && plansByGroup.length === 0" style="color:red;">Não há planos com este tipo de ação para este plano.</span>
            </div>
          </div>
          <div class="col-md-6" v-show="planChangeType !== null && plansByGroup.length > 0">
            <div class="form-group">
              <label for="exampleFormControlTextarea1"
              >Novo Plano de Mensalidade</label
              >
              <select
                class="form-control input i-width"
                v-model="body.planId"
                required
              >
                <option :value="null" selected disabled>Selecione...</option>
                <template v-for="optgroup in plansByGroup">
                  <optgroup v-if="optgroup.groupId" :label="optgroup.groupName" :key="`optgroup-${optgroup.groupId}`">
                    <option v-for="plan in optgroup.plans" :value="plan.planId" :key="`plan-${plan.planId}`">
                      {{ plan.name }} - R${{ (plan.price - 20).toFixed(2).replace('.', ',') }} c/ fid. ou
                      R${{ plan.price.toFixed(2).replace('.', ',') }}
                    </option>
                  </optgroup>
                </template>
              </select>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label for="exampleFormControlTextarea1"
              >Carteira de Cobrança</label
              >
              <select v-model="body.cobCart" class="form-control input i-width" required>
                <option :value="null" selected disabled>Selecione...</option>
                <option v-for="f in field.cobCarts" :key="`cobCart-${f.id}`" :value="f.id">{{ f.name }}</option>
              </select>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label for="exampleFormControlTextarea1">Dia de Vencimento</label>
              <select class="form-control input i-width" v-model="body.expireDay" required>
                <option :value="null" selected disabled>Selecione...</option>
                <option v-for="f in field.expirationDates" :key="`expDate-${f.id}`" :value="f.id">{{ f.name }}</option>
              </select>
            </div>
          </div>

          <div v-show="body.equipmentChange" class="col-md-3">
            <fg-input
              type="date"
              label="Agendamento OS"
              v-model="body.date"
            ></fg-input>
          </div>
        </div>
        <hr>
        <div>
          <input
            type="checkbox"
            v-model="body.useClientAddress"
          />
          <label style="margin-left: 5px" for="endereço">
            <span style="font-weight: bold;">Usar mesmo endereço cadastrado no cliente</span>
          </label>
        </div>
        <br>
        <div v-show="!body.useClientAddress">
          <div>
            <span class="address">Endereço do Novo Ponto</span>
          </div>
          <br>
          <div class="row">
            <div class="col-md-3">
              <fg-input
                type=""
                label="CEP"
                v-mask="'########'"
                v-model="body.zipCode"
                required
              ></fg-input>
            </div>

            <div class="col-md-6">
              <fg-input
                type="text"
                label="Endereço"
                @keyup.native="toUpperAddress"
                v-model="body.address"
                required
              ></fg-input>
            </div>
            <div class="col-md-2">
              <fg-input
                type="number"
                label="Número"
                v-model="body.addressNumber"
                required
              ></fg-input>
            </div>
          </div>

          <div class="row">
            <div class="col-md-2">
              <fg-input
                type=""
                label="Cidade"
                @keyup.native="toUpperCity"
                v-model="body.city"
                required
              ></fg-input>
            </div>

            <div class="col-md-2">
              <fg-input
                type="text"
                label="Bairro"
                @keyup.native="toUpperDistrict"
                v-model="body.district"
                required
              ></fg-input>
            </div>
            <div class="col-md-7">
              <fg-input
                type="text"
                label="Complemento"
                @keyup.native="toUpperAddressExtra"
                v-model="body.addressExtra"
                required
              ></fg-input>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label>Observações O.S</label>
              <textarea
                rows="5"
                class="form-control border-input"
                v-model="body.observations"
              ></textarea>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-4">
            <div>
              <input
                type="checkbox"
                id="fidelidade"
                name="fidelidade"
                v-model="body.loyalty"
              />
              <label style="margin-left: 5px" for="fidelidade">
                <span class="p_fidelidade">Ponto possui fidelidade ?</span>
              </label>
            </div>
          </div>
          <div class="col-md-4">
            <div>
              <input
                type="checkbox"
                id="equipamento"
                name="equipamento"
                v-model="body.equipmentChange"
              />
              <label style="margin-left: 5px" for="equipamento">
                <span class="p_fidelidade">Possui troca de equipamento ?</span>
              </label>
            </div>
          </div>
        </div>
        <div class="clearfix"></div>

        <div class="container_buttons">
          <button class="btn-custom btn-salvar">Atualizar Ponto</button>
        </div>
      </form>
    </div>
  </card>
</template>

<script>
import Swal from "sweetalert2";
import {mapActions} from "vuex";

export default {
  computed: {
    plans() {
      return this.$store.getters.plans;
    },
    field() {
      return this.$store.getters.leadFields;
    },
  },
  methods: {
    ...mapActions(["fetchPointData", "fetchPlans", "updatePoint", "fetchLeadFields"]),
    toUpperAddress(e) {
      this.point.address = e.target.value.toUpperCase();
    },
    toUpperCity(e) {
      this.point.city = e.target.value.toUpperCase();
    },
    toUpperDistrict(e) {
      this.point.district = e.target.value.toUpperCase();
    },
    toUpperAddressExtra(e) {
      this.point.addressExtra = e.target.value.toUpperCase();
    },
    updatePlanList() {
      this.fillPlansByGroup();
    },
    fillPlansByGroup() {
      const groupNames = new Map([
        [27, 'Internet'],
        [28, 'Global Móvel'],
        [29, 'TV'],
        [33, 'Internet NK'],
      ]);
      this.plansByGroup = [];
      this.plans.forEach(plan => {
        if (this.planChangeType === '1074' && this.point.plan.price >= plan.price) {
          return;
        } else if (this.planChangeType === '1107' && this.point.plan.price <= plan.price) {
          return;
        } else if (this.planChangeType === '1099' && this.point.plan.price !== plan.price) {
          return;
        }

        const index = this.plansByGroup.findIndex(p => p.groupId === plan.groupId);
        if (index > -1) {
          this.plansByGroup[index].plans.push(plan);
        } else {
          this.plansByGroup.push({
            groupId: plan.groupId,
            groupName: groupNames.get(plan.groupId) || plan.groupId,
            plans: [plan]
          });
        }
      });
      console.log(this.plansByGroup);
      console.log(this.plans);
      return this.plansByGroup;
    },
    async updatePlan() {
      if (this.body.equipmentChange && !this.body.date) {
        await Swal.fire("Ops!", "É necessário agendar uma data para a troca de equipamento.", "warning");
        return;
      }
      try {
        Swal.fire({
          title: "Processando!",
          html: "Alterando plano...",
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });
        await this.updatePoint({
          body: {
            ...this.body,
            pointId: this.$route.params.pointId,
            clientId: this.$route.params.clientId,
            planActionType: this.planChangeType,
          },
        });
        Swal.close();
        await Swal.fire("Sucesso!", "Plano de ponto foi atualizado.", "success");
        this.$router.push(`/clientes/${this.$route.params.clientId}/visualizar`);
      } catch (err) {
        await Swal.fire("Ops!", "Não foi possível atualizar completamente o ponto.", "error");
      }
    }
  },
  data() {
    return {
      point: null,
      body: {
        planId: null,
        loyalty: false,
        useClientAddress: true,
        cobCart: null,
        zipCode: '',
        address: '',
        city: '',
        district: '',
        addressNumber: '',
        addressExtra: '',
        expireDay: null,
        date: "",
        observations: '',
        equipmentChange: false,
      },
      planChangeType: null,
      loading: false,
      plansByGroup: [],
    };
  },
  async mounted() {
    const [point] = await Promise.all([
      this.fetchPointData({pointId: this.$route.params.pointId, clientId: this.$route.params.clientId}),
      this.fetchPlans(),
      this.fetchLeadFields(),
    ]);
    this.point = point;
    this.body.cobCart = point.cobCart;
    this.body.expireDay = point.dueDay;
    this.body.zipCode = point.zipCode;
    this.body.address = point.address;
    this.body.city = point.city;
    this.body.district = point.district;
    this.body.addressNumber = point.addressNumber;
    this.body.addressExtra = point.addressExtra;
  },
};
</script>

<style lang="scss" scoped>
.p_fidelidade {
  font-weight: bold;
  color: #000;
  font-size: 18px;
}

span.address {
  font-size: 22px;
  font-weight: bold;
}

.btn-custom {
  color: #f4f3ef;
  border: none;
  border-radius: 7px;
  font-size: 13px;
  font-weight: bold;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  padding: 13px 20px;
  transition: all 0.5s;

  &.btn-salvar {
    background: #9dcf6b;
    padding: 13px 25px;

    &:hover {
      background: #82ac58;
    }
  }

  &.btn-analise {
    margin-left: 10px;
    background: orange;

    &:hover {
      background: #c07e03;
    }
  }
}
</style>
